module.exports = __webpack_public_path__ + "img/bul_menu_charset.3ff7d867.svg";